"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _PatternTypes = require("./PatternTypes");

const kScaleFromEdge = 0.08;

class PatternUtils {
  getPatternOutlinePoints(patternType) {
    switch (patternType) {
      case _PatternTypes.PatternTypes.SixFoldReflectedFilter:
      case _PatternTypes.PatternTypes.SixFoldRotatedFilter:
        return [[0.5, 0.14], [kScaleFromEdge, 1.0 - 0.14], [1.0 - kScaleFromEdge, 1.0 - 0.14]];

      case _PatternTypes.PatternTypes.EightFoldReflectedFilter:
        return [[1.0 - kScaleFromEdge, 1.0 - 1.0 / 1.15], [kScaleFromEdge, 1.0 - kScaleFromEdge], [1.0 - kScaleFromEdge, 1.0 - kScaleFromEdge]];

      case _PatternTypes.PatternTypes.TwelveFoldReflectedFilter:
        return [[1.0 - kScaleFromEdge, 1.0 - 1.0 / 1.26], [kScaleFromEdge, 1.0 + 1.0 / 1.95 - 1.0 / 1.26], [1.0 - kScaleFromEdge, 1.0 + 1.0 / 1.95 - 1.0 / 1.26]];

      default:
        return [];
    }
  }

}

var _default = new PatternUtils();

exports.default = _default;